import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import moment from 'moment'
import MUIDataTable from 'mui-datatables'
class FandBSalesReports extends React.Component {
  state = {
    Store_list: [],
    shopName: '',
    start_date: '',
    end_date: '',
    Data: [],
  }

  componentDidMount() {
    this.dashbord()
    this.saleSummary()
  }

  dashbord = async () => {
    var that = this

    await axios
      .get(Constant.getAPI() + '/store/store-name-listing', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            Store_list: res.data.data,
          })
        }
      })
      .catch((err) => {
        that.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  saleSummary = async () => {
    var dateDMY1 = moment(this.state.start_date).format('MM/DD/YYYY')
    var dateDMY2 = moment(this.state.end_date).format('MM/DD/YYYY')
    let data = {
      shopName: this.state.shopName ? this.state.shopName : '',
      createdAtFrom: dateDMY1 === 'Invalid date' ? '' : dateDMY1,
      createdAtTo: dateDMY2 === 'Invalid date' ? '' : dateDMY2,
    }

    axios
      .post(Constant.getAPI() + `/reports/f-and-b-sales`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(
        (response) => {
          // let link = Constant.getImage() + response?.data?.data?.reportUrl;
          // window.location.href = lin
          this.setState({
            Data: response?.data?.data?.data,
            reportUrl: response?.data?.data?.reportUrl,
          })
        },
        (error) => {
          Swal.fire({
            title: error?.response?.data?.data || error?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      )
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }
  download = () => {
    let link = Constant.getImage() + this.state.reportUrl
    window.location.href = link
  }
  render() {
    const columns = [
      {
        name: 'CUSTOMER_NAME',
        label: 'CUSTOMER NAME',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'phone',
        label: 'PHONE',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'RESTURANT_NAME',
        label: 'RESTURANT NAME',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'ITEM_NAME',
        label: 'ITEM NAME',
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: 'Total',
        label: 'Total',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'DELIVERY CHARGE',
        label: 'DELIVERY CHARGE',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'DATE',
        label: 'DATE',
        options: {
          filter: true,
          sort: true,
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>F and B Sales Summary Reports</h4>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">F and B Sales Summary Reports</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <button
              onClick={this.download}
              className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
            >
              <i className="icofont icofont-download"></i> F&B Sales Summary Report
            </button>

            <div className="">
              <div className="card-body">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Shop Name</label>
                    <div className="col-sm-9">
                      <select
                        name="shopName"
                        className="form-control"
                        onChange={this.handleChange}
                        value={this.state.shopName}
                      >
                        <option>Select Shop Name</option>
                        {this.state.Store_list !== undefined &&
                        this.state.Store_list !== null &&
                        this.state.Store_list !== [] &&
                        this.state.Store_list.length > 0
                          ? this.state.Store_list.map((Store_list) => (
                              <option
                                value={Store_list.shop_name_en}
                                key={Store_list.id}
                              >
                                {Store_list.shop_name_en}
                              </option>
                            ))
                          : null}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Created Start Date</label>
                    <div className="col-sm-9">
                      <input
                        type="date"
                        id="date"
                        name="start_date"
                        className="form-control"
                        onChange={this.handleChange}
                        value={this.state.start_date}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Created End Date</label>
                    <div className="col-sm-9">
                      <input
                        type="date"
                        id="date"
                        name="end_date"
                        className="form-control"
                        onChange={this.handleChange}
                        value={this.state.end_date}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="row float-right p-3"
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                  }}
                >
                  <button
                    onClick={this.saleSummary}
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                  >
                    Filter
                  </button>
                </div>
                <div className="page-body">
                  <div
                    className="row"
                    style={{ width: '100%' }}
                  >
                    <div className="col-sm-12">
                      <div className="card">
                        <div className="card-block">
                          <div className="dt-responsive table-responsive">
                            {this.state.Data?.length > 0 && (
                              <MUIDataTable
                                title={'New Cruise Report'}
                                className="table-responsive"
                                data={this.state.Data}
                                columns={columns}
                                options={options}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default FandBSalesReports
